import { register, registerWithUserID, trackEvent, trackPageView } from './internal/analytics';

export const analytics = {
  register,
  registerWithUserID,
  trackEvent,
  trackPageView,
};
